import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import LayoutContextProvider from '@/context/AppAuthContext';
import { AppLayoutHeader } from './AppLayoutHeader';
import { AppLayoutAsideNew } from './AppLayoutAsideNew';

import 'react-toastify/dist/ReactToastify.css';

export const AppLayout = () => {
  return (
    <LayoutContextProvider>
      <div className="flex bg-[#F8F9FC] text-slate-500 dark:bg-zinc-900 dark:text-slate-300">
        <AppLayoutAsideNew>
          <main className="min-h-screen w-full overflow-auto">
            <AppLayoutHeader />
            <div className="min-h-[calc(100vh-64px)] bg-gray-50 px-2 py-2 dark:bg-gray-900">
              <Outlet />
            </div>
          </main>
        </AppLayoutAsideNew>
      </div>
      <ToastContainer />
    </LayoutContextProvider>
  );
};
